import { AltBuilding } from 'store/alt-buildings/types';
import { FailureActionPayload } from '../errors/types';
import { createAsyncAction } from 'typesafe-actions';

export const getAltBuildings = createAsyncAction(
  'GET_ALT_BUILDINGS_REQUEST',
  'GET_ALT_BUILDINGS_SUCCESS',
  'GET_ALT_BUILDINGS_FAILURE',
)<string, Array<AltBuilding>, FailureActionPayload>();
